import CipHeader from "./CipHeader";

import { useForm } from "react-hook-form";
import React,{useState} from "react";
import cmn_services from "../services/common-service";
import cogoToast from "cogo-toast";
import {  withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { setBarCoderesultList } from "../state/reducers/barCodeResultSlice";
import { BASE_URL } from '../constants/api';
import Loader from "react-loader-spinner";



const SearchBarcode = ({ setBarCoderesultList, history }) => {
  const {register, handleSubmit, errors } = useForm({});
  const [loading, setLoading] = useState(false);
  const onSubmit = async (data) => {
    try {
      setLoading(true);
      const getbarCodeDetails = await cmn_services.getFromServer(
        BASE_URL + "Returns/" + data.barCode
      );
      setLoading(false);
      if (getbarCodeDetails.status !== 200) {
        const barCodeDetails = getbarCodeDetails;
        await setBarCoderesultList({ barCodeDetails });
        await history.push("/returnForm");
      }else{
        const { hide } = cogoToast.error("BarCode Not Found", {hideAfter:15,
          onClick: () => {
            hide();
          },
        });  
        setLoading(false);
      }
    } catch (e) {
      if(e.code==="400"){
        const { hide } = cogoToast.error(e.msg, {hideAfter:15,
          onClick: () => {
            hide();
          },
        });
        setLoading(false);
      }
      else{
        const { hide } = cogoToast.error("Records Not Found!", {hideAfter:15,
          onClick: () => {
            hide();
          },
        });
        setLoading(false);
      }
    }
  };
  return (
    <>
      <CipHeader />
      <div className={`inline-block customtop absolute z-50 ${loading ? "show" : "hidden"}`}>
        <Loader
          type="Oval"
          color="#00B2A9"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <div className="bg-white w-1/2 mx-auto mt-12">
        <div className="text-left py-5 pr-5 pl-14 shadow-subheader text-darkclr font-semibold text-lg">RETURNS APPLICATION</div>
        <div className="py-5 w-5/6 mx-auto text-left">
          <h1 className="font-semibold text-md mt-5 mb-4 pb-4 border-b text-darkclr">
            INSTRUCTIONS
          </h1>
          <form onSubmit={handleSubmit(onSubmit)}>
            <ul className="text-menu_txt text-base">
              <li className="inline-block  leading-10 w-full">
                1. Place the mouse cursor in the textbox below.
              </li>
              <li className="inline-block leading-10 w-full">
                2. Use the barcode scanner to scan the medicine you intend to
                return.
              </li>
              <li className="inline-block leading-10 w-full mb-6">
                3. Click the "Submit Barcode" button when the barcode 
                <span className="ml-5 block">
                information populates the textbox.</span>
              </li>
              <li className={`inline-block leading-10 w-full mb-4`}>
                <input
                  type="text"
                  name="barCode"
                  autoFocus={true}
                  placeholder="Enter Barcode"
                  ref={register({
                    required: "You must enter barcode",
                  })}
                  className={`border focus:outline-none focus:none h-10 rounded-md pl-3 text-sm font-normal w-full mb-3 ${(errors.barCode) ? "border-red-400" : ""}`}
                />
                {(errors.barCode) && (
                    <p className='text-xs md:text-sm md:pt-1 text-hlred'>
                      {errors.barCode?.message}
                    </p>
                  )}
              </li>
              <li className="inline-block leading-11 w-full">
                <button
                  label="Submit"
                  className="text-white rounded font-semibold h-10 w-full bg-header_bg mb-3"
                >
                  SUBMIT BARCODE
                </button>
               
              </li>
            </ul>
          </form>
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({ setBarCoderesultList }, dispatch);
    }
  )(SearchBarcode)
);
